export default "__VITE_ASSET__Z9nu$Lk5__"